var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 152.65 152.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#505050;}.cls-2{fill:#9ca5ad;}.cls-3{fill:#0c0c0c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.59,76.34A76.21,76.21,0,1,1,76.31,0,76.28,76.28,0,0,1,152.59,76.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.6,114.86c.47,3.28-3.63,1.7-7.21,5.11s-4.5,5.36-8.77,3.22c-3.82-1.91,2.9-10.91,6-12S117.93,110.21,118.6,114.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.94,129.86a76.35,76.35,0,0,0,11.23,9.4c2.95-4.36,7.52-8.69,13.65-7.27,15.16,3.52,18-29.72,2.06-28.77-13,.78-2.76-13-15.93-9a18.11,18.11,0,0,1-4.35.76C19.5,110.63,16.54,123.78,21.94,129.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.86,78.86c4.07-1.12,14.88-4.3,17.56-15.84C46.25,50.79,29.94,47.2,33.21,39.54,36.8,31.14,65.92,42.22,65.92,29c0-7.28-8.65-5.25-14.48-6.7C44.21,20.49,41.08,14.7,40,9.22A76.47,76.47,0,0,0,.66,66.28c-.06.43-.12.85-.17,1.27C.42,68.2.36,68.84.3,69.49s-.09,1.07-.12,1.6S.09,72.3.06,72.9s0,1.29,0,1.94C0,76,0,77.12,0,78.27c0,.33,0,.67,0,1,0,.87.08,1.74.15,2.61l0,.43q.24,3,.7,5.93a76.63,76.63,0,0,0,5.62,19.07l0,0c.5,1.13,1,2.25,1.59,3.35l.16.32c.52,1,1.06,2,1.63,3,.08.15.17.3.26.45.54,1,1.11,1.88,1.7,2.8l.3.48q.9,1.38,1.86,2.73l.27.38c.68.94,1.38,1.87,2.1,2.78l.15.18a76.63,76.63,0,0,0,5.35,6c-5.4-6.08-2.44-19.23,6.66-34.92C17,95.45,13.6,82.23,25.86,78.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.7,64.44a75.92,75.92,0,0,0-17.38-37.71,52.07,52.07,0,0,0-4.67,5.63c-3.63,5-11.18,5.23-15.3-2.92a17.68,17.68,0,0,0-6.48-7.16c-7.52,2.91-16.18,7.81-25.25,14.37-1.5,6.79.54,14.42,12.1,15.26C109.73,53,102,68,92.91,64.64S79.26,58,71.75,63.94s-6.22,16.12,2.78,17.58c6.39,1,9.67,10,7.17,12.84-3.55,3.13-8.55,15.68-1.86,23.09s11.73,2.19,13.63-2.15,2-7.21,5.39-13c2.56-4.31,11.43-6.22,11.43-6.22s7.31-2.62,2.23-16.16S125.1,68.64,129,77.77c3.25,7.63-4.47,20.17,9.18,18,6.12-1,8.48,2.1,10.72,4.19A75.8,75.8,0,0,0,151.7,64.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.92,35.45c-.12.4-.21.8-.3,1.2,9.07-6.56,17.73-11.46,25.25-14.37C99.38,17.06,87.23,20.34,82.92,35.45Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 126.81,
    cy: 30.53,
    r: 14.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.69,35.24l-6.88-.86-6.88.86a3.84,3.84,0,0,0-3.37,3.81v1.14a14.05,14.05,0,0,0,20.5,0V39.05A3.84,3.84,0,0,0,133.69,35.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.81,45.8a15.27,15.27,0,1,1,15.27-15.27A15.29,15.29,0,0,1,126.81,45.8Zm0-28.18a12.92,12.92,0,1,0,12.92,12.91A12.93,12.93,0,0,0,126.81,17.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.94,28c0,3.54-2.3,6.41-5.13,6.41s-5.12-2.87-5.12-6.41,2.29-5.12,5.12-5.12S131.94,24.43,131.94,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.81,35.55c-3.47,0-6.3-3.4-6.3-7.58a6.3,6.3,0,0,1,12.6,0C133.11,32.15,130.29,35.55,126.81,35.55Zm0-11.53c-1.47,0-4,.52-4,3.95,0,2.89,1.77,5.23,4,5.23s3.95-2.34,3.95-5.23C130.76,24.54,128.29,24,126.81,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.81,45.8A15.11,15.11,0,0,1,115.71,41a1.14,1.14,0,0,1-.32-.8V39.05a5,5,0,0,1,4.39-5l6.89-.86H127l6.88.86h0a5,5,0,0,1,4.4,5v1.14a1.19,1.19,0,0,1-.32.8A15.15,15.15,0,0,1,126.81,45.8Zm-9.07-6.09a12.88,12.88,0,0,0,18.15,0v-.66a2.68,2.68,0,0,0-2.34-2.65l-6.74-.84-6.74.84a2.68,2.68,0,0,0-2.33,2.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 36.38,
    cy: 15.27,
    r: 14.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.27,20l-6.89-.86L29.5,20a3.85,3.85,0,0,0-3.37,3.82v1.13a14.05,14.05,0,0,0,20.5,0V23.79A3.85,3.85,0,0,0,43.27,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.38,30.53A15.27,15.27,0,1,1,51.65,15.27,15.27,15.27,0,0,1,36.38,30.53Zm0-28.18A12.92,12.92,0,1,0,49.3,15.27,12.93,12.93,0,0,0,36.38,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.51,12.71c0,3.53-2.3,6.4-5.13,6.4s-5.12-2.87-5.12-6.4,2.29-5.13,5.12-5.13S41.51,9.17,41.51,12.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.38,20.28c-3.47,0-6.3-3.4-6.3-7.57a5.91,5.91,0,0,1,6.3-6.3,5.9,5.9,0,0,1,6.3,6.3C42.68,16.88,39.86,20.28,36.38,20.28Zm0-11.53c-1.47,0-4,.52-4,4,0,2.88,1.77,5.23,4,5.23s3.95-2.35,3.95-5.23C40.33,9.27,37.86,8.75,36.38,8.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.38,30.53a15.07,15.07,0,0,1-11.1-4.81,1.13,1.13,0,0,1-.32-.8V23.79a5,5,0,0,1,4.39-5L36.24,18a.71.71,0,0,1,.29,0l6.88.86h0a5,5,0,0,1,4.4,5v1.13a1.17,1.17,0,0,1-.32.8A15.09,15.09,0,0,1,36.38,30.53Zm-9.07-6.09a12.86,12.86,0,0,0,18.15,0v-.65a2.67,2.67,0,0,0-2.34-2.65l-6.74-.85-6.73.85a2.66,2.66,0,0,0-2.34,2.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 46.95,
    cy: 59.89,
    r: 14.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.83,64.6,47,63.74l-6.88.86a3.84,3.84,0,0,0-3.37,3.81v1.14a14.05,14.05,0,0,0,20.5,0V68.41A3.84,3.84,0,0,0,53.83,64.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47,75.16A15.27,15.27,0,1,1,62.22,59.89,15.28,15.28,0,0,1,47,75.16ZM47,47A12.92,12.92,0,1,0,59.87,59.89,12.93,12.93,0,0,0,47,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.08,57.33c0,3.54-2.3,6.41-5.13,6.41s-5.12-2.87-5.12-6.41,2.29-5.12,5.12-5.12S52.08,53.79,52.08,57.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47,64.91c-3.47,0-6.3-3.4-6.3-7.58A5.91,5.91,0,0,1,47,51a5.91,5.91,0,0,1,6.3,6.3C53.25,61.51,50.43,64.91,47,64.91Zm0-11.53c-1.47,0-4,.52-4,3.95,0,2.89,1.77,5.23,4,5.23s3.95-2.34,3.95-5.23C50.9,53.9,48.43,53.38,47,53.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47,75.16a15.11,15.11,0,0,1-11.1-4.81,1.14,1.14,0,0,1-.32-.8V68.41a5,5,0,0,1,4.39-5l6.89-.86h.29l6.88.86h0a5,5,0,0,1,4.4,5v1.14a1.19,1.19,0,0,1-.32.8A15.13,15.13,0,0,1,47,75.16Zm-9.07-6.09a12.88,12.88,0,0,0,18.15,0v-.66a2.68,2.68,0,0,0-2.34-2.65L47,64.92l-6.73.84a2.68,2.68,0,0,0-2.34,2.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 31.69,
    cy: 136.23,
    r: 14.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.57,140.93l-6.88-.86-6.89.86a3.85,3.85,0,0,0-3.36,3.82v1.13a14,14,0,0,0,20.49,0v-1.13A3.85,3.85,0,0,0,38.57,140.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.69,151.5A15.27,15.27,0,1,1,47,136.23,15.29,15.29,0,0,1,31.69,151.5Zm0-28.19A12.92,12.92,0,1,0,44.6,136.23,12.93,12.93,0,0,0,31.69,123.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.81,133.67c0,3.54-2.29,6.4-5.12,6.4s-5.13-2.86-5.13-6.4,2.29-5.13,5.13-5.13S36.81,130.13,36.81,133.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.69,141.25c-3.48,0-6.3-3.4-6.3-7.58a5.9,5.9,0,0,1,6.3-6.3,5.9,5.9,0,0,1,6.29,6.3C38,137.85,35.16,141.25,31.69,141.25Zm0-11.53c-1.48,0-4,.51-4,3.95,0,2.88,1.78,5.23,4,5.23s3.95-2.35,3.95-5.23C35.64,130.23,33.16,129.72,31.69,129.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.69,151.5a15.13,15.13,0,0,1-11.11-4.81,1.21,1.21,0,0,1-.32-.81v-1.13a5,5,0,0,1,4.4-5l6.88-.86h.29l6.88.86h0a5,5,0,0,1,4.4,5v1.13a1.17,1.17,0,0,1-.32.81A15.13,15.13,0,0,1,31.69,151.5Zm-9.08-6.09a12.88,12.88,0,0,0,18.15,0v-.66a2.68,2.68,0,0,0-2.34-2.65l-6.73-.84L25,142.1a2.68,2.68,0,0,0-2.34,2.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 77.49,
    cy: 92.78,
    r: 14.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.37,97.48l-6.88-.86-6.89.86a3.85,3.85,0,0,0-3.36,3.82v1.13a14.05,14.05,0,0,0,20.5,0V101.3A3.85,3.85,0,0,0,84.37,97.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.49,108A15.27,15.27,0,1,1,92.75,92.78,15.28,15.28,0,0,1,77.49,108Zm0-28.18A12.92,12.92,0,1,0,90.41,92.78,12.93,12.93,0,0,0,77.49,79.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.61,90.22c0,3.53-2.29,6.4-5.12,6.4s-5.13-2.87-5.13-6.4,2.3-5.13,5.13-5.13S82.61,86.68,82.61,90.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.49,97.8c-3.48,0-6.3-3.41-6.3-7.58a5.9,5.9,0,0,1,6.3-6.3,5.91,5.91,0,0,1,6.3,6.3C83.79,94.39,81,97.8,77.49,97.8Zm0-11.54c-1.48,0-3.95.52-3.95,4,0,2.88,1.77,5.23,3.95,5.23s4-2.35,4-5.23C81.44,86.78,79,86.26,77.49,86.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.49,108a15.09,15.09,0,0,1-11.11-4.81,1.17,1.17,0,0,1-.32-.8V101.3a5,5,0,0,1,4.4-5l6.88-.86a.71.71,0,0,1,.29,0l6.88.86h0a5,5,0,0,1,4.4,5v1.13a1.13,1.13,0,0,1-.32.8A15.07,15.07,0,0,1,77.49,108ZM68.41,102a12.86,12.86,0,0,0,18.15,0v-.65a2.66,2.66,0,0,0-2.34-2.65l-6.73-.85-6.74.85a2.67,2.67,0,0,0-2.34,2.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 137.38,
    cy: 104.52,
    r: 14.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.26,109.23l-6.88-.87-6.88.87a3.84,3.84,0,0,0-3.37,3.81v1.13a14.05,14.05,0,0,0,20.5,0V113A3.84,3.84,0,0,0,144.26,109.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.38,119.79a15.27,15.27,0,1,1,15.27-15.27A15.29,15.29,0,0,1,137.38,119.79Zm0-28.19a12.92,12.92,0,1,0,12.92,12.92A12.94,12.94,0,0,0,137.38,91.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.51,102c0,3.54-2.3,6.4-5.13,6.4s-5.12-2.86-5.12-6.4,2.29-5.13,5.12-5.13S142.51,98.42,142.51,102Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.38,109.54c-3.47,0-6.3-3.4-6.3-7.58a6.3,6.3,0,0,1,12.6,0C143.68,106.14,140.85,109.54,137.38,109.54Zm0-11.53c-1.47,0-3.95.51-3.95,3.95,0,2.88,1.77,5.23,3.95,5.23s4-2.35,4-5.23C141.33,98.52,138.86,98,137.38,98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.38,119.79a15.11,15.11,0,0,1-11.1-4.81,1.17,1.17,0,0,1-.32-.81V113a5,5,0,0,1,4.39-5l6.89-.86a1.4,1.4,0,0,1,.29,0l6.88.86h0a5,5,0,0,1,4.4,5v1.13a1.21,1.21,0,0,1-.32.81A15.15,15.15,0,0,1,137.38,119.79Zm-9.07-6.09a12.88,12.88,0,0,0,18.15,0V113a2.68,2.68,0,0,0-2.34-2.65l-6.74-.84-6.74.84a2.68,2.68,0,0,0-2.33,2.65Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.bb4556aaf86d13c7b691c5c83c5782b1.svg";
export { ForwardRef as ReactComponent };